export default {
  english: {
    message: 'This post can\'t be displayed because social networks cookies have been deactivated. You can activate them by clicking',
  },
  french: {
    message: 'Ce post ne peut être affiché car les cookies pour les réseaux sociaux sont désactivés. Vous pouvez les réactiver en cliquant sur',
  },
  arabic: {
    message: 'This post can\'t be displayed because social networks cookies have been deactivated. You can activate them by clicking',
  },
  hebrew: {
    message: 'לא ניתן להציג מכיוון שעוגיות רשתות חברתיות חסומות. ניתן להפעיל בלחיצה כאן',
  },
  persian: {
    message: 'این پست نمایش داده نمی شود زیرا کوکی های شبکه های اجتماعی غیرفعال شده اند. با کلیک کردن می توانید آنها را فعال کنید',
  },
}
